import classNames from "classnames";
import { useState, type KeyboardEvent } from "react";
import BaseInputControl from "./BaseInputControl";
import type { HandleInputChange } from "./types";

type PasswordInputProps = {
    name: string;
    value?: string | number;
    placeholder?: string;
    disabled?: boolean;
    onChange: HandleInputChange;
};

const PasswordInput = ({ name, value, placeholder, disabled, onChange }: PasswordInputProps) => {
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        if (disabled) return;
        setShowPassword((isVisible) => !isVisible);
    };

    const handleToggleKeyDown = (event: KeyboardEvent<HTMLSpanElement>) => {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            togglePasswordVisibility();
        }
    };

    const visibilityLabel = showPassword ? "Hide password" : "Show password";

    return (
        <div className="input-group">
            <BaseInputControl
                type={showPassword ? "text" : "password"}
                name={name}
                value={value}
                placeholder={placeholder}
                disabled={disabled}
                onChange={onChange}
            />
            <span
                className="input-group-text user-select-none"
                role="button"
                tabIndex={disabled ? -1 : 0}
                onClick={togglePasswordVisibility}
                onKeyDown={handleToggleKeyDown}
                title={visibilityLabel}
                aria-label={visibilityLabel}
                aria-pressed={showPassword}
                aria-disabled={disabled}
            >
                <i
                    className={classNames("bi fs-5", {
                        "bi-eye": !showPassword,
                        "bi-eye-slash": showPassword,
                    })}
                    aria-hidden="true"
                />
            </span>
        </div>
    );
};

export default PasswordInput;
